/**
 * Data-attribute markers for dnd-kit drag surfaces — the single source for
 * the marker names. Spread onto any dnd-kit draggable node (useSortable /
 * useDraggable handle) and onto the child of `<DragOverlay>`:
 * `<Box {...DND_DRAGGABLE_PROPS} />`.
 *
 * The attributes do nothing by themselves — the companion CSS ships in this
 * package's `index.css` (`[data-dnd-draggable]` / `[data-dnd-overlay]`).
 * Without it, long-pressing a draggable on iOS triggers native text
 * selection and the system drag ghost instead of a clean dnd-kit drag.
 */
export const DND_DRAGGABLE_PROPS = {
  "data-dnd-draggable": "true",
} as const;

export const DND_OVERLAY_PROPS = {
  "data-dnd-overlay": "true",
} as const;
